import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Routes from '../routes/routes';
import { useRoutes, navigate } from 'hookrouter';
import NavBar from '../NavBar/navbar';
import './forms.css';
import TemplateBuilder from '../template-builder/builder';
import FormRenderer from '../form-renderer/form-usage';
import { AppBar, Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: theme.spacing(3),
  },
}));

function CRF() {
  useRoutes(Routes);

  if (localStorage.getItem('auth') !== 'true') {
    navigate('/', true);
  }

  const classes = useStyles();
  const [tab, setTab] = useState(0);
  const [isTemplateBuilder, setType] = useState(true);
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newTab) => {
    setValue(newTab);
    setTab(newTab);
    if (tab) setType(true);
    else setType(false);
  };

  return (
    <>
      <NavBar />
      <Paper elevation={8} className={classes.root}>
        <AppBar position="static" color="default">
          <Tabs
            value={tab}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="white"
            variant="fullWidth"
            centered
          >
            <Tab label="Create Template" {...a11yProps(0)} />
            <Tab label="Upload Data" {...a11yProps(1)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <TemplateBuilder />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <FormRenderer />
        </TabPanel>
      </Paper>
    </>
  );
}

export default CRF;
